<script>
import ValidatesUsers from "./mixins/validates-users";
import toasts from "../../mixins/toasts";

export default Vue.extend({
  mixins: [ValidatesUsers, toasts],
  data() {
    return {
      loading: false,
      modified: false,
      limit: 2,
      preset: {
        employee: {},
        student: {
          profile: {
            type: "bachelor",
            enrollment_year: new Date().getFullYear()
          }
        }
      },
      users: []
    };
  },
  computed: {
    limitReached() {
      return this.users.length >= this.limit;
    }
  },
  methods: {
    back: function() {
      window.history.back();
    },
    appendUser(type) {
      if (this.limitReached) {
        return false;
      }

      this.users.push(
        this.applyDefault(
          {
            _meta: {
              index: this.users.length,
              info: {
                modal: false,
                initial: false,
                errors: false
              }
            },
            type: type,
            info: {},
            profile: {
              position: {},
              department: {}
            }
          },
          type
        )
      );
    },
    removeUser(user) {
      let loading = this.$loading.open();
      _.delay(() => {
        this.users.splice(user._meta.index, 1);
        let index = 0;
        _.each(this.users, u => {
          u._meta.index = index++;
        });
        this.modified = this.users.length;
        loading.close();
      }, 400);
    },
    validateUserInfo(user) {
      user._meta.info.initial = false;
      let loading = this.$loading.open();
      this.$validator
        .validateAll("user." + user._meta.index + ".info")
        .then(valid => {
          _.delay(() => {
            loading.close();
            user._meta.info.modal = false;
            user._meta.info.errors = !valid;
          }, 400);
        });
    },
    applyDefault(user, type) {
      return _.merge(user, this.preset[type]);
    },
    revalidate() {
      this.$validator.validateScopes();
    },
    submit() {
      if (!this.modified) {
        return;
      }
      this.$validator.validateScopes().then(valid => {
        _.each(this.users, user => {
          valid = valid && !(user._meta.info.errors || user._meta.info.initial);
        });
        if (valid) {
          this.loading = true;
          let loading = this.$loading.open();
          setTimeout(() => {
            axios
              .post("/api/users", this.users)
              .then(response => {
                this.users = [];
                this.loading = false;
                this.modified = false;
                loading.close();
                this.$dialog.confirm({
                  title: "Отчёт создан",
                  message: `Пользователи были успешно добавлены.
                                    <br><br>
                                    Хотите открыть отчёт?`,
                  cancelText: "Нет",
                  confirmText: "Да",
                  type: "is-success",
                  hasIcon: true,
                  onConfirm: () => {
                    this.$loading.open();
                    location.href = `/reports?show=${response.data.id}`;
                  }
                });
              })
              .catch(error => {
                switch (error.response.status) {
                  case 403: {
                    this.toast(
                      "warning",
                      "Создание пользователя с такими параметрами недоступно"
                    );
                    break;
                  }
                  default: {
                    this.toast("error", "@unexpected", error);
                  }
                }
                this.loading = false;
                loading.close();
              });
          }, 2000);
        } else {
          this.modified = false;
          this.toast("error", "@invalid");
        }
      });
    }
  }
});
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/views/users/Create.vue